<div class="smallPage flexRow">
  <div class="left-background width-70"></div>
  <div class="right-background width-30"></div>
  <div class="main">
    <img src="./assets/login/big.png" class="big-img" alt="" style="left: -50px" />
    <img src="./assets/login/logo.png" class="logo" alt="" style="left: 0" />
    <img src="./assets/login/medium.png" class="medium-img" alt="" style="left: -80px" />
    <div class="big-title" style="left: 0">Welcome</div>
    <div class="little-title" style="left: 0">欢迎进入星晨管理系统</div>
    <img src="./assets/login/main-bg.png" class="main-bg" alt="" style="left: 0" />
    <img src="./assets/login/fine.png" class="fine-img" alt="" style="right: -40px" />
    <div class="login-form-body" style="right: 0">
      <form nz-form (ngSubmit)="login()" style="width: 100%; height: 100%">
        <div class="login-form">
          <div class="login-type-box flexRow">
            <div class="login-type-tab selectTab flexFull">账号登录</div>
            <!--            <div class="interval"></div>-->
            <!--            <div class="login-type-tab flexFull">扫码登录</div>-->
          </div>
          <div class="login-box">
            <ng-container *ngIf="type == 1">
              <div class="d-flex justify-content-between align-items-center">
                <div class="text-md fontBolder">短信验证</div>
                <div class="d-flex pointer" (click)="type = 2">
                  <div
                    class="icon-right text-primary pl-sm mr-sm"
                    style="background: url('assets/bg-1.png') no-repeat; background-size: contain"
                  >
                    账号密码
                  </div>
                  <i nz-icon nzIconfont="icon_mimayanzheng" class="icon-sm"></i>
                </div>
              </div>
              <div class="error-box">
                <div *ngIf="error_type != ''" class="error-body flexRow selfRadius">
                  <i nz-icon nzIconfont="xcjinggao" class="error-icon"></i>
                  <ng-container *ngIf="error_type == 'verifyNote'">手机号错误</ng-container>
                </div>
              </div>
              <div class="login-form-item">
                <nz-input-group
                  [nzPrefix]="telIcon"
                  class="login-form-item-input selfRadius"
                  [ngClass]="{ error: error_type == 'mobileNote' }"
                >
                  <input
                    type="text"
                    [(ngModel)]="mobileNote"
                    nz-input
                    maxlength="11"
                    placeholder="请输入手机号"
                    class="input-item"
                    (keyup)="keyup()"
                    (input)="checkForm()"
                    (ngModelChange)="changeError('mobileNote')"
                    [ngModelOptions]="{ standalone: true }"
                  />
                </nz-input-group>
                <ng-template #telIcon>
                  <i nz-icon nzIconfont="icon_tel" class="text-gray1"></i>
                </ng-template>
              </div>
              <div class="login-form-item" style="height: 32px">
                <com-slide-verify
                  #slideVerifier1
                  [initText]="'按住滑块，拖动到最右侧'"
                  [sucessText]="'通过验证'"
                  (sure)="sureSlider($event)"
                ></com-slide-verify>
              </div>
              <div class="login-form-item flexRow" [ngStyle]="{ visibility: verifyShow ? 'visible' : 'hidden' }">
                <input
                  type="text"
                  [(ngModel)]="verifyNote"
                  nz-input
                  placeholder="请输入4位数字验证码 "
                  style="width: 168px; height: 40px; margin-right: 8px"
                  class="selfRadius"
                  maxlength="4"
                  (keyup)="keyup()"
                  (input)="checkForm()"
                  (ngModelChange)="changeError('verifyNote')"
                  [ngModelOptions]="{ standalone: true }"
                />
                <button style="width: 144px; height: 40px" type="button" nz-button (click)="getCaptcha()" [disabled]="count > 0" nzBlock>
                  {{ count ? count + '秒后重新获取' : countFirst == 1 ? '获取短信验证码' : '重新获取' }}
                </button>
              </div>
              <div class="mt-sm text-gray1 mb-sm" style="height: 20px">
                <span *ngIf="count">验证码已发送到您的手机，有效期 5 分钟。</span>
              </div>
              <div class="login-form-item flexRow selfRadius mb-xl" style="background: #c7dbff">
                <button
                  nz-button
                  nzType="primary"
                  [disabled]="!validate['status']"
                  [nzGhost]="!validate['status']"
                  class="login-button selfRadius"
                  type="submit"
                >
                  <span style="color: #fff">登录</span>
                </button>
              </div>
            </ng-container>
            <ng-container *ngIf="type == 2">
              <div class="d-flex justify-content-between align-items-center">
                <div class="text-md fontBolder">账号密码</div>
                <div class="d-flex pointer" (click)="type = 1; verifyShow = false">
                  <div
                    class="icon-right text-primary pl-sm mr-sm"
                    style="background: url('assets/bg-1.png') no-repeat; background-size: contain"
                  >
                    短信验证
                  </div>
                  <i nz-icon nzIconfont="icon_duanxinyanzheng" class="icon-sm"></i>
                </div>
              </div>
              <div class="error-box">
                <div *ngIf="error_type != ''" class="error-body flexRow selfRadius">
                  <i nz-icon nzIconfont="xcjinggao" class="error-icon"></i>
                  <ng-container *ngIf="error_type == 'mobile'">手机号错误</ng-container>
                  <ng-container *ngIf="error_type == 'password'">密码错误错误</ng-container>
                  <ng-container *ngIf="error_type == 'captcha'">验证码错误</ng-container>
                </div>
              </div>
              <div class="login-form-item">
                <nz-input-group [nzPrefix]="telIcon" class="login-form-item-input selfRadius" [ngClass]="{ error: error_type == 'mobile' }">
                  <input
                    type="text"
                    [(ngModel)]="mobile"
                    nz-input
                    maxlength="11"
                    placeholder="请输入手机号"
                    class="input-item"
                    (input)="checkForm()"
                    (ngModelChange)="changeError('mobile')"
                    [ngModelOptions]="{ standalone: true }"
                  />
                </nz-input-group>
                <ng-template #telIcon>
                  <i nz-icon nzIconfont="icon_tel" class="text-gray1"></i>
                </ng-template>
              </div>
              <div class="login-form-item">
                <nz-input-group
                  [nzPrefix]="pwdIcon"
                  [nzSuffix]="lookIcon"
                  class="login-form-item-input selfRadius"
                  [ngClass]="{ error: error_type == 'password' }"
                >
                  <input
                    type="{{ !pwdShowType ? 'password' : 'text' }}"
                    [(ngModel)]="password"
                    nz-input
                    placeholder="请输入密码"
                    class="input-item"
                    (blur)="checkForm()"
                    (ngModelChange)="changeError('password')"
                    [ngModelOptions]="{ standalone: true }"
                  />
                </nz-input-group>
                <ng-template #pwdIcon>
                  <i nz-icon nzIconfont="icon_password" class="text-gray1"></i>
                </ng-template>
                <ng-template #lookIcon>
                  <i nz-icon nzIconfont="icon_view" class="text-gray1 clickEle" (click)="pwdShowType = !pwdShowType"></i>
                </ng-template>
              </div>
              <div class="login-form-item flexRow">
                <input
                  type="text"
                  [(ngModel)]="verify"
                  nz-input
                  placeholder="请输入验证码 "
                  style="width: 200px; height: 40px; margin-right: 8px"
                  class="selfRadius"
                  (keyup)="checkForm()"
                  maxlength="4"
                  [ngClass]="{ error: error_type == 'captcha' }"
                  (ngModelChange)="changeError('captcha')"
                  [ngModelOptions]="{ standalone: true }"
                />
                <img
                  src="{{ verifyData['img'] }}"
                  style="width: 112px; height: 38px"
                  alt="验证码"
                  (click)="getVerify()"
                  class="selfRadius clickEle"
                />
              </div>
              <div class="login-form-item flexRow selfRadius" style="background: #c7dbff">
                <button
                  nz-button
                  nzType="primary"
                  [disabled]="!validate['status']"
                  [nzGhost]="!validate['status']"
                  class="login-button selfRadius"
                  type="submit"
                >
                  <span style="color: #fff">登录</span>
                </button>
              </div>
              <div class="login-form-item forget-pwd">
                <a class="text-gray1" routerLink="/passport/password-set" [queryParams]="{ type: 2 }">忘记密码</a>
              </div>
            </ng-container>
            <div class="login-form-item" style="height: 20px !important">
              <nz-divider [nzText]="text" class="more-login-type">
                <ng-template #text><span>更多登录方式</span></ng-template>
              </nz-divider>
            </div>
            <div class="login-form-item">
              <button nz-button class="wx-login" type="button" (click)="wxLogin()">
                <i nz-icon nzIconfont="icon_wechat_gray" class="wx-icon"></i>微信登陆
              </button>
            </div>
          </div>
        </div>
      </form>
      <img src="./assets/login/grid.png" class="grid-img" alt="" />
    </div>
  </div>
</div>
